<!--
  ~ Copyright (c) 2019. Sonrai Analytics Ltd.
  ~ Developed by Deva Sen. & Warren Dowey
  -->

<div [class]="'app-container'">
  <div>
    <div class="app-main__inner splash-screen">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
